import { createConfig, http, injected } from '@wagmi/core';
import { metaMask, walletConnect } from '@wagmi/connectors';
import { supportedChains } from './evm-chains';
const walletConnector = walletConnect({
    projectId: 'd3483196fbaa8259ab4191347c67f973',
    qrModalOptions: {
        themeMode: 'dark',
    },
});
export const wagmiConfig = createConfig({
    chains: supportedChains,
    connectors: [injected(), walletConnector, metaMask()],
    transports: Object.fromEntries(supportedChains.map(chain => [chain.id, http()])),
});
